import React from "react";
import { useNavigate } from "react-router-dom";
import { useHotel } from "@/hooks/useHotel";
import { useServiceCreate } from "./hooks/useServiceCreate";
import HotelServiceForm from "./components/ServiceForm";
import { CreateHotelServiceFormData } from "./utils/serviceSchema";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const AddServicePage = () => {
  const { hotelId } = useHotel();
  const navigate = useNavigate();
  const { handleHotelServiceCreateSubmit, isLoading } = useServiceCreate();

  const handleCreate = async (
    data: CreateHotelServiceFormData,
    file: File | null
  ) => {
    await handleHotelServiceCreateSubmit(data, hotelId!, file);
    navigate("/services");
  };

  return (
    <div className="relative min-h-screen p-6 flex flex-col">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate("/services")}
        className="absolute left-12 top-12 flex items-center gap-2 font-semibold"
      >
        <ArrowLeft className="h-4 w-4" />
        Back
      </Button>
      <HotelServiceForm
        onSubmit={handleCreate}
        isSubmitting={isLoading}
        submitButtonText="Create Service"
        titleText="Add Service"
      />
    </div>
  );
};

export default AddServicePage;
